import React, { useState, useEffect } from "react";
import {
  Modal,
  ModalBody,
  ModalHeader,
  ModalFooter,
  Spinner,
  Input
} from "reactstrap";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { consignmentService } from "../../../../../services/consignment.services";
import dateFormat from "dateformat";
import { FaTrash } from "react-icons/fa";


const AcceptModal = (props) => {
  const [loading, setLoading] = useState(false);
  const [comment, setComment] = useState(""); 
  const [selectedDate, setSelectedDate] = useState(null); 
  const [error, setError]=  useState([]);
  const [selectedKits, setSelectedKits] = useState([]);
  const [kits, setKits] = useState([]);
  const [deletedKits, setDeletedKits] = useState([]);

  useEffect(() => {
    if (props.isOpen) {
        // console.log("KITS RECEIVED", props.kits);
      setSelectedDate(props.deliveryDate ? new Date(props.deliveryDate) : null);
      // setSelectedKits(
      //   props.kits?.map((kit) => kit._id) || []
      // );
       setKits(props.kits || []);

      setSelectedKits(
        props.kits?.map((kit) => kit._id) || []
      );
    }
  }, [props.isOpen, props.deliveryDate, props.kits]);

  const modalClose = (flag) => {
    props.toggle(flag);
    setError([]);
    setComment("");
    setSelectedDate(null);
    setSelectedKits([]);
    setKits([]);
    setDeletedKits([]);

  };

  const handleDeleteKit = (kitId) => {
    if (kits.length <= 1) {
      setError({
        ...error,
        kits: "At least one kit must remain in the consignment."
      });
      return;
    }

    setDeletedKits((prev) => [...prev, kitId]);

    setKits((prev) => prev.filter((kit) => kit._id !== kitId));

    setSelectedKits((prev) =>
      prev.filter((id) => id !== kitId)
    );

    setError((prev) => ({
      ...prev,
      kits: null
    }));
  };
  const handleKitChange = (kitId) => {
    setSelectedKits((prev) =>
      prev.includes(kitId)
        ? prev.filter((id) => id !== kitId)
        : [...prev, kitId]
    );
  };
  const handleAccept = async () => {
    // const totalKits = props.kits.length;
    const totalKits = kits.length;
    const selectedCount = selectedKits.length;

    let consignmentStatus = "pending";

    if (selectedCount === totalKits) {
      consignmentStatus = "booked";
    } else if (selectedCount > 0) {
      consignmentStatus = "partial";
    }

    // const kitsData = props.kits.map((kit) => ({
      const kitsData = props.kits.map((kit) => ({
      id: kit._id,
      kitId: kit.kitId,
      status: selectedKits.includes(kit._id),
      deleted: deletedKits.includes(kit._id)
    }));

    console.log("Consignment Status:", consignmentStatus);
    // console.log("kitsData:", kitsData);

    setLoading(true);

    const params = {
      id: props.bookingId,
      comment,
      delivery_date: dateFormat(selectedDate, "yyyy-mm-dd"),
      status: consignmentStatus,
      kits: kitsData
    };

    console.log("params", params);
    try {
      const response = await consignmentService.acceptConsingnment(params);

      console.log("API response:", response);

      modalClose(true);
      props.onReload();
    } catch (error) {
      console.error("API call failed:", error);
      setError(error);
    } finally {
      setLoading(false);
    }
  };

  const handlePartialBook = async () => {

    const totalKits = kits.length;
    const selectedCount = selectedKits.length;

    // Partial booking ke liye
    // kuch selected aur kuch unselected hona chahiye

    if (selectedCount === 0) {
        setError({
            kits: "Please select at least one kit."
        });
        return;
    }

    if (selectedCount === totalKits) {
        setError({
            kits: "Please unselect at least one kit for partial booking."
        });
        return;
    }

    if (!selectedDate) {
        setError({
            delivery_date: "Please select delivery date."
        });
        return;
    }

    if (!comment.trim()) {
        setError({
            comment: "Please enter comment."
        });
        return;
    }

    const kitsData = props.kits.map((kit) => ({
        id: kit._id,
        kitId: kit.kitId,
        status: selectedKits.includes(kit._id),
        deleted: deletedKits.includes(kit._id)
    }));

    const params = {
        id: props.bookingId,
        comment,
        delivery_date: dateFormat(
            selectedDate,
            "yyyy-mm-dd"
        ),
        kits: kitsData
    };

    console.log("PARTIAL BOOK PARAMS", params);

    setLoading(true);

    try {

        const response =
            await consignmentService.partialBookConsignment(params);

        console.log(
            "Partial booking response:",
            response
        );

        modalClose(true);

        props.onReload();

    } catch (error) {

        console.error(
            "Partial booking failed:",
            error
        );

        setError(
            error?.response?.data?.data?.errors ||
            error?.response?.data ||
            error
        );

    } finally {
        setLoading(false);
    }
  };

  return (
    <Modal
      size="md"
      backdrop="static"
      centered
      isOpen={props.isOpen}
      toggle={() => modalClose(false)}
    >
      <ModalHeader toggle={() => modalClose(false)}>
        Accept Booking
      </ModalHeader>
      <ModalBody>
        <div>Are you sure you want to Accept Booking?</div>
        <div className="mt-3">
          <label htmlFor="datePicker">Delivery Date <span className="text-danger">*</span></label>
          <DatePicker
            id="datePicker"
            selected={selectedDate}
            onChange={(date) => setSelectedDate(date)}
            className="form-control"
            dateFormat="yyyy/MM/dd"
            placeholderText="Select date"
          />
           {error.delivery_date && (
            <span className="text-danger">{error.delivery_date}</span>
          )}
        </div>
        
        <div className="mt-3">
          <label>
            Kits <span className="text-danger">*</span>
          </label>

          <div className="border rounded p-2">
            {kits && kits.length > 0 ? (
              kits.map((kit) => (
            <div
              key={kit._id}
              className="d-flex justify-content-between align-items-center mb-2"
            >
              <div className="form-check">
                <input
                  type="checkbox"
                  className="form-check-input"
                  id={`kit-${kit._id}`}
                  checked={selectedKits.includes(kit._id)}
                  onChange={() => handleKitChange(kit._id)}
                  disabled={kit.status === "accept"}

                />

                <label
                  className="form-check-label"
                  htmlFor={`kit-${kit._id}`}
                >
                  {kit.kits?.[0]?.name} ({kit.stock_level})
                </label>
              </div>
                {kit.status !== "accept" && (
            //   <button
            //   type="button"
            //   className="btn btn-sm btn-danger"
            //   disabled={(kits.length <= 1)}
            //   onClick={() => handleDeleteKit(kit._id)}
            // >
            //   Delete
            // </button>

              <button
                type="button"
                className="btn btn-sm text-danger"
                disabled={kits.length <= 1}
                onClick={() => handleDeleteKit(kit._id)}
                title="Delete Kit"
              >
                <FaTrash size={16} />
              </button>
                )}
            </div>
              ))
            ) : (
              <div>No kits available</div>
            )}
          </div>
          {error.kits && (
            <span className="text-danger">{error.kits}</span>
          )}
        </div>

        <div className="mt-3">
          <label htmlFor="comment">Comment <span className="text-danger">*</span></label>
          <Input
            id="comment"
            type="textarea"
            placeholder="Enter comment"
            value={comment}
            onChange={(e) => setComment(e.target.value)} 
          />
           {error.comment && (
            <span className="text-danger">{error.comment}</span>
          )}
        </div>
      </ModalBody>
      <ModalFooter>
        <div>
          <button
            onClick={() => modalClose(false)}
            className="btn btn-secondary mr-2"
            data-dismiss="modal"
          >
            Cancel
          </button>
          {!loading && (
            <button
              className="btn btn-primary mr-2"
              onClick={handleAccept}
            >
              Update
            </button>
          )}
          {loading && (
            <button
              className="btn btn-primary loader-icon mr-2"
              disabled
            >
              <Spinner className="img-svg"></Spinner>
            </button>
          )}
          {!loading && (
            <button
              className="btn btn-primary"
              onClick={handlePartialBook}
              // disabled={kits.length <= 1}
              disabled={selectedKits.length === kits.length || kits.length <= 1}
            >
              Partial Book
            </button>
          )}
          {loading && (
            <button
              className="btn btn-primary loader-icon"
              disabled
            >
              <Spinner className="img-svg"></Spinner>
            </button>
          )}
        </div>
      </ModalFooter>
    </Modal>
  );
};

export default AcceptModal;
